import { render, staticRenderFns } from "./specification.vue?vue&type=template&id=df7d50dc&scoped=true&"
import script from "./specification.vue?vue&type=script&lang=js&"
export * from "./specification.vue?vue&type=script&lang=js&"
import style0 from "./specification.vue?vue&type=style&index=0&id=df7d50dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7d50dc",
  null
  
)

export default component.exports